import type { MigratedPlotFormProps } from '../../../../forms/formHandlerShared';
import CoupledDimensionPlotForm from '../shared/CoupledDimensionPlotForm';

function WindRosePlotForm(props: MigratedPlotFormProps) {
  return <CoupledDimensionPlotForm {...props} widget="windrose" />;
}

export default WindRosePlotForm;
